import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from 'src/app/core/guards/auth.guard';
import { CustomRouteData } from 'src/app/core/utils/routing-util';
import { EditMyProfileComponent } from './edit-my-profile.component';

export const editMyProfileRoutes: Routes = [
  {
    path: '',
    component: EditMyProfileComponent,
    canActivate: [authGuard],
    data: <CustomRouteData>{
      entitlementUrl: '' // TODO: add entitlements?
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(editMyProfileRoutes)],
  exports: [RouterModule]
})
export class EditMyProfileRoutingModule {}
